module.exports = __webpack_public_path__ + "static/media/hyperinvertor.1cdf4f26.jpg";